import objectAssign from 'object-assign';
import initialState from './initialState';

import {
  RECEIVE_LEADS,
  HANDLE_LEADS_ERROR
} from '../actions/actionTypes';

export function leads(state = initialState.leads, action) {
  let newState;
  switch (action.type) {
    case RECEIVE_LEADS:
      newState = objectAssign({}, state);
      newState = action.leads;
      return newState;
    default:
      return state;
  }
}

export function leadsError(state = initialState.leadsError, action) {
  let newState;
  switch(action.type) {
    case HANDLE_LEADS_ERROR:
      newState = objectAssign({}, state);
      newState = action.leadsError;
      return newState;
    default:
      return state;
  }
}
